import { v4 as uuidv4 } from 'uuid';
import { clientStatuses, clientStatusEnums } from 'utils';
import { CLIENT_ACTION, renderClientName, renderStaffName } from './constants';
import { apptEnums } from '../../../../fragments/schedule/core/constants';
import { BREAK, DRIVE, PAID, SERVICE, SICK_TIME, STAFF, UNPAID } from '../../../../fragments/schedule/constants';

const activeAuthClientStatuses = [
    { id: clientStatusEnums.ACTIVE, name: 'Active' },
    { id: clientStatusEnums.FBA, name: 'FBA' },
    { id: clientStatusEnums.WAIT_LIST, name: 'Waitlist' },
    { id: clientStatusEnums.ON_HOLD, name: 'On Hold' },
];

export const clientApptReport = () => {
    return {
        title: 'Client Appointments Report',
        url: '/reports/client/appts',
        list: [
            {
                type: 'selectMultipleWidthPagination',
                name: 'clients',
                label: 'Client',
                reqType: 'client',
                renderValue: (option) => renderClientName(option),
            },
            {
                type: 'select',
                name: 'clientStatus',
                label: 'Client Status',
                renderValue: (option) => option?.name,
                selectList: [...clientStatuses],
            },
            {
                type: 'dos',
                startDate: 'startDate',
                endDate: 'endDate',
                startLabel: 'Appt. Start Date',
                endLabel: 'Appt. End Date',
                required: true,
            },
            {
                type: 'select',
                name: 'status',
                label: 'Appt. Status',
                selectList: [
                    { id: apptEnums?.COMPLETED, name: 'Completed' },
                    { id: apptEnums?.PENDING, name: 'Pending' },
                    { id: apptEnums?.CANCELLED, name: 'Cancelled' },
                ],
                renderValue: (option) => option?.name,
            },
            {
                type: 'selectMultipleWidthPagination',
                name: 'staffs',
                label: 'Staff',
                reqType: 'staff',
                renderValue: (option) => renderStaffName(option),
            },
            {
                type: 'select',
                name: 'serviceType',
                label: 'Service Type',
                selectList: [
                    { id: 'DIRECT', name: 'Direct' },
                    { id: 'INDIRECT', name: 'Indirect' },
                ],
                renderValue: (option) => option?.name,
            },
        ],
    };
};

export const noShowCancelApptReport = () => {
    return {
        title: 'Appt. No-Show/Cancellation Report',
        url: '/reports/client/appts/canceled',
        list: [
            {
                type: 'selectMultipleWidthPagination',
                name: 'clients',
                label: 'Client',
                reqType: 'client',
                renderValue: (option) => renderClientName(option),
            },
            {
                type: 'selectMultipleWidthPagination',
                name: 'staffs',
                label: 'Staff',
                reqType: 'staff',
                renderValue: (option) => renderStaffName(option),
            },
            // {
            //     type: 'selectMultiple',
            //     name: 'clients',
            //     label: 'Client',
            //     loadType: CLIENT_ACTION,
            //     renderValue: (option) => renderClientName(option),
            // },
            // {
            //     type: 'selectMultiple',
            //     name: 'staffs',
            //     label: 'Staff',
            //     loadType: 'GET_ADMINS',
            //     renderValue: (option) => renderStaffName(option),
            // },
            {
                type: 'dos',
                startDate: 'startDate',
                endDate: 'endDate',
                startLabel: 'Appt. Start Date',
                endLabel: 'Appt. End Date',
                required: true,
            },
            {
                type: 'date',
                name: 'canceledDate',
                label: 'Cancelled Date',
            },
        ],
    };
};

export const authorizationDeadlineSnapshotReport = () => {
    return {
        title: 'Authorization Deadline Report',
        url: '/reports/client/auth/deadline',
        list: [
            {
                type: 'dos',
                startDate: 'authServiceStartDate',
                endDate: 'authServiceEndDate',
                startLabel: 'Start Date',
                endLabel: 'End Date',
                required: true,
            },
        ],
    };
};
export const activeAuthByServiceTypeReport = () => {
    return {
        title: 'Active Authorization Report by Service Type',
        url: '/reports/client/auth/active-by-service-type',
        list: [
            {
                type: 'select',
                name: 'clientStatus',
                label: 'Client Status',
                renderValue: (option) => option?.name,
                selectList: activeAuthClientStatuses,
                required: true,
            },
            {
                type: 'select',
                name: 'serviceTypeId',
                label: 'Service Type',
                renderValue: (option) => option?.name,
                required: true,
            },
        ],
    };
};

export const clientStatusReport = () => {
    return {
        title: 'Client Status Report',
        url: '/reports/client/status',
        list: [
            {
                type: 'select',
                name: 'clientStatus',
                label: 'Client Status',
                renderValue: (option) => option?.name,
                selectList: [...clientStatuses],
                required: true,
            },
        ],
    };
};

export const clientReportEnums = [
    {
        id: uuidv4(),
        name: 'Client Appointments Report',
        description: 'List of client appointments with dates, statuses, and assigned staff.',
        generateInfo: clientApptReport(),
    },
    {
        id: uuidv4(),
        name: 'Appt. No-Show/Cancellation Report',
        description: 'Canceled and no-show appointments with reasons and cancellation details.',
        generateInfo: noShowCancelApptReport(),
    },
    {
        id: uuidv4(),
        name: 'Authorization Deadline Report',
        description: 'Comprehensive report of authorized services, including detailed information and usage metrics.',
        generateInfo: authorizationDeadlineSnapshotReport(),
    },
    {
        id: uuidv4(),
        name: 'Active Authorization Report by Service Type',
        description: 'Active authorizations filtered by client status and service type with unit utilization details.',
        generateInfo: activeAuthByServiceTypeReport(),
    },
    {
        id: uuidv4(),
        name: 'Client Status Report',
        description:
            'Clients in a selected status with the status they were changed from, status date, funding source and their authorizations.',
        generateInfo: clientStatusReport(),
    },
];
